
import _ from "lodash-es";
import dayjs from "dayjs";
import { parseInt } from "lodash";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import {
  candidateDefaultColumnsGen,
  HeaderColumn,
  HeaderShowType
} from "@/views/exam-v3/config/list";
import { Post } from "@/lib/newExam/post";
import Auth from "@/lib/common/auth";
import TimeUtil from "@/lib/common/time-util";
import {
  EnumAiRecommendStatus,
  EnumAuditStatus,
  EnumCandidateListSortKey,
  EnumMessageStatus,
  EnumProcessStatus,
  EnumSubmitStatus
} from "@/lib/model/exambuilder/candidate-v3/candidate-v3-enum";
import { CandidateV3Item } from "@/lib/model/exambuilder/candidate-v3/candidate-v3";
import vuexStore from "@/store/vuex-store";
import ExamList, { CompanyIdParam } from "@/lib/model/exam/exam";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import Candidate, { CandidateGet, MDelete } from "@/lib/model/exam/candidate";
import NR from "@/lib/model/NRXQ/NRXQ";
import Loading from "@/components/loading.vue";
import AskGoOn from "@/components/ask-go-on.vue";
import ErrorDialog from "@/views/ai-builder/components/delete-dialog.vue";
import TablePop from "@/components/table-pop.vue";
import EllipShow from "@/components/ellipShow.vue";
import TableSortDialog from "./tableSortDialog.vue";
import CandidateItem from "./candidateItem.vue";
import AddCandidateTags from "./add-candidate-tags.vue";
import EditCandidateRemark from "./edit-candidate-remark.vue";
import SendCandidateAsk from "./send-candidate-ask.vue";
import ReCandidateInterview from "./re-candidate-interview.vue";
import AsyncDownloadModal from "./async-download-modal.vue";
import {
  ExamVDList,
  ExamVDVersionListRequest
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import { CompanyConfig } from "@/lib/common/acm";
import { EnumTagMap, EnumTagType, EnumTagColor } from "@/lib/enum/tags";
import Decrypt from "@/lib/model/decryptParams/decryptParams";

//异常项
enum errorEnum {
  "faceCheck" = "候选人身份认证失败",
  "bgCheckIdentity" = "候选人手机号实名未通过",
  "bgCheckSocial" = "候选人存在社会安全风险",
  "bgCheckFinancial" = "候选人存在金融风险",
  "eyeColor" = "候选人辨色检测未通过",
  "replacePerson" = "候选人面试过程中疑似换人",
  "faceDetection" = "候选人露脸检测未通过",
  "screenshot" = "候选人面试过程中多次截屏",
  "mobileJoinCount" = "候选人面试过程中多次切屏",
  "finger" = "候选人手部检测未通过",
  "readCheating" = "候选人面试过程中疑似念稿",
  "webJump" = "候选人Web作答中疑似切屏",
  "keyboardSoundDetection" = "候选人面试过程中出现键盘声音"
}

interface SortMap {
  key: EnumCandidateListSortKey;
  dict: "asc" | "desc";
  label: string;
}

@Component({
  components: {
    AsyncDownloadModal,
    ErrorDialog,
    AskGoOn,
    Loading,
    EllipShow,
    TablePop,
    TableSortDialog,
    CandidateItem,
    AddCandidateTags,
    EditCandidateRemark,
    SendCandidateAsk,
    ReCandidateInterview
  }
})
export default class CandidatesTable extends Vue {
  @Prop({ type: String, default: "all" })
  scene!: "exam" | "all";
  @Prop({ type: Number, default: 0 })
  examId!: number;
  @Prop({ type: Array, default: () => [] })
  headerParams!: string[];
  @Prop({ type: Array, default: () => [] })
  data!: CandidateV3Item[];
  @Prop({ type: Number, default: 0 })
  total!: number;
  @Prop({ type: Boolean, default: true })
  loading!: boolean;
  @Prop({ type: CandidateListForm, default: () => new CandidateListForm() })
  searchForm!: CandidateListForm;

  // 因为服务器的压力，用户疯狂点击查询全部信息，数据库压力很大。限制了返回的总数， 超过9999的都显示9999+
  get totalShow() {
    let totalLimit = 9999;
    if (process.env.NODE_ENV === "production") {
      totalLimit = 9999;
    }
    if (this.total >= totalLimit) {
      return `${totalLimit}+`;
    } else {
      return this.total;
    }
  }

  get EnumProcessStatus() {
    return EnumProcessStatus;
  }

  get HeaderShowType() {
    return HeaderShowType;
  }

  get useMultiTag() {
    return CompanyConfig.getInstance().useMultiTag === 1;
  }

  get storageKey() {
    let key = `${Auth.companyId}_${Auth.userId}_candidateListV3`;

    if (this.scene === "exam") {
      key += `_${this.examId}`;
    }

    return key;
  }

  // 批次
  versionList: { value: number; label: string }[] = [];
  version = "";
  versionName = "";

  async getVersionList() {
    const res = await ExamVDList.getVersionList(
      new ExamVDVersionListRequest().assign({ examId: this.examId })
    );

    const len = res.data.list.length;
    this.versionList = res.data.list.map((item: any, index: number) => ({
      value: item.examVersionId,
      label: `批次${len - index}`
    }));
    this.getShowHeaderList();
    this.$nextTick(() => this.initSelectInputStyle());
  }

  handleClearVersion() {
    this.versionName = "";
    this.searchForm.examVersionId = 0;
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickVersionOption(value: number, name: string) {
    if (this.searchForm.examVersionId === value) {
      this.version = "";
      this.versionName = "";
      this.searchForm.examVersionId = 0;
    } else {
      this.versionName = name;
      this.searchForm.examVersionId = value;
    }
    this.searchForm.page = 1;
    this.refresh();
  }

  // AI推荐结果
  aiRecommend = "";
  aiRecommendName = "";

  handleClearAiRecommend() {
    this.aiRecommendName = "";
    this.searchForm.aiRecommendStatusList = [];
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickAiRecommend(value: number, name: string) {
    if (this.searchForm.aiRecommendStatusList[0] === value) {
      this.aiRecommend = "";
      this.aiRecommendName = "";
      this.searchForm.aiRecommendStatusList = [];
    } else {
      this.aiRecommendName = name;
      this.searchForm.aiRecommendStatusList = [value];
    }
    this.searchForm.page = 1;
    this.refresh();
  }

  // 岗位
  positionList: Post[] = [];
  position = "";
  positionName = "";

  handleClearPosition() {
    this.positionName = "";
    this.searchForm.positionId = 0;
    this.searchForm.page = 1;
    this.refresh();
  }

  handleClickPositionOption(value: number, name: string) {
    if (this.searchForm.positionId === value) {
      this.position = "";
      this.positionName = "";
      this.searchForm.positionId = 0;
    } else {
      this.positionName = name;
      this.searchForm.positionId = value;
    }
    this.searchForm.page = 1;
    this.refresh();
  }

  // 日期
  getOptions(key: string) {
    const today = dayjs(new Date()).format("YYYY-MM-DD");
    const todayStartTime = new Date(`${today} 00:00:00`).getTime();
    const endTime = new Date(`${today} 23:59:59`);

    return {
      shortcuts: [
        {
          text: "最近三天",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 3);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近三天";
            this.watchChange = false;
          }
        },
        {
          text: "最近一周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近一周";
            this.watchChange = false;
          }
        },
        {
          text: "最近两周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 14);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近两周";
            this.watchChange = false;
          }
        },
        {
          text: "最近一个月",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, endTime]);
            this[key] = "最近一个月";
            this.watchChange = false;
          }
        }
      ]
    };
  }

  beginTimeMsg = "";
  createTimePickerOptions = this.getOptions("beginTimeMsg");

  submitTimeMsg = "";
  submitTimePickerOptions = this.getOptions("submitTimeMsg");

  // 是否触发监听以便修改input框中的展示内容
  watchChange = true;

  handleChangeDateSelector(value: string[], key: string) {
    this.searchForm.page = 1;
    this.refresh();

    if (!this.watchChange) return (this.watchChange = true);

    this[key] = value?.map(t => t.split(" ")[0]).join("～") || "";
  }

  // 标签
  tagList: string[] = [];
  tagNameMsg = "";
  tagSearch = "";
  searchTagsBeckUp: string[] = [];

  get filterTagList() {
    if (!this.tagSearch) return this.tagList;

    return this.tagList.filter(tag => tag.includes(this.tagSearch));
  }

  handleChangeTag(val: string[]) {
    this.tagNameMsg = val.join("，");
  }

  handleChangeTagVisible(res: boolean) {
    if (res) {
      this.searchTagsBeckUp = this.searchForm.tagNameList;
    } else {
      const change = !_.isEqual(
        this.searchTagsBeckUp,
        this.searchForm.tagNameList
      );

      if (change) {
        this.searchForm.page = 1;
        this.refresh();
      }
    }
  }

  // 排序
  sortMap: SortMap[] = [
    {
      key: EnumCandidateListSortKey.BeginTime,
      dict: "desc",
      label: "按面试开始时间由近及远"
    },
    {
      key: EnumCandidateListSortKey.BeginTime,
      dict: "asc",
      label: "按面试开始时间由远及近"
    },
    {
      key: EnumCandidateListSortKey.ScoreAi,
      dict: "asc",
      label: "按AI评分从低到高"
    },
    {
      key: EnumCandidateListSortKey.ScoreAi,
      dict: "desc",
      label: "按AI评分从高到低"
    }
  ];
  sort = "默认排序";

  handleClickSortOption(item: SortMap) {
    if (this.sort === item.label) {
      this.sort = "默认排序";
      this.searchForm.sortKey = "";
      this.searchForm.sortDict = "";
    } else {
      this.sort = item.label;
      this.searchForm.sortKey = item.key || "";
      this.searchForm.sortDict = item.dict || "";
    }

    this.refresh();
  }

  // 获取候选人筛选功能会用到的信息(全部面试的自定义登记信息并集、标签、岗位)
  async getListFeaturesList() {
    const params = new CompanyIdParam();
    params.companyId = Auth.companyId;
    const res = await ExamList.companyTags(params);

    if (res.code !== 0) return;

    this.tagList = res.data.tag;

    if (this.scene === "all") {
      this.positionList = res.data.positions;
      this.paramList = res.data.paramName;
    }
  }

  // 表头相关
  paramList: string[] = [];
  hoverSelectAll = false;
  tableHeaderReady = true;
  showSortSetting = false;
  headerList: HeaderColumn[] = [];
  defaultHeaderList: HeaderColumn[] = [];
  showHeaderList: HeaderColumn[] = [];

  V = vuexStore;

  // 列表相关
  tableKey = 1;
  isWideList = true;

  @Watch("isWideList")
  handleChangeListStyle() {
    localStorage.setItem(
      `style_${this.storageKey}`,
      this.isWideList ? "wide" : "normal"
    );
  }

  // 自定义列更新
  @Watch("paramList", { deep: true })
  paramNameChange() {
    const headerListJSON = localStorage.getItem(this.storageKey);

    // 新生成表头
    if (!headerListJSON) return this.getShowHeaderList();

    try {
      const list = JSON.parse(headerListJSON);
      this.getShowHeaderList(list);
    } catch (err) {
      this.getShowHeaderList();
    }
  }

  // 获取表头显示的项
  getShowHeaderList(cacheData?: HeaderColumn[]) {
    const candidateDefaultColumns = candidateDefaultColumnsGen(
      this.useMultiTag
    );
    // 过滤默认项
    const params = this.paramList
      .filter(param => {
        const isDefault = candidateDefaultColumns.some(
          item => item.label === param
        );
        return !["姓名", "手机"].includes(param) && !isDefault;
      })
      .map((param, index) => ({
        label: param,
        prop: param,
        required: false,
        isShow: false,
        draggable: true,
        showType: HeaderShowType.Param,
        minWidth: "200px",
        sort: candidateDefaultColumns.length + 1 + index
      }));

    this.defaultHeaderList = candidateDefaultColumns.concat(params);

    this.defaultHeaderList = this.defaultHeaderList.filter(item => {
      if (this.scene === "exam") {
        const map =
          this.versionList.length > 1
            ? ["positionName", "examName"]
            : ["positionName", "examName", "version"];

        return !map.includes(item.prop || "");
      }

      return !["version"].includes(item.prop || "");
    });

    this.headerList = this.genHeaderList(cacheData);
    this.showHeaderList = this.headerList.filter(item => item.isShow);
  }
  // 重新定义表头，防止公司级别权限修改时只走缓存不更新
  genHeaderList(cacheData?: HeaderColumn[]) {
    if (!cacheData) return this.defaultHeaderList;
    const newData = [];
    for (let item of this.defaultHeaderList) {
      const hasItem = cacheData.find(child => child.prop === item.prop);
      if (hasItem) {
        hasItem.label = item.label;
        newData.push(hasItem);
      } else {
        item.isShow = false;
        newData.push(item);
      }
    }
    return newData;
  }

  // 展示表头管理器
  showTableSetting() {
    this.showSortSetting = true;
    const selector = ".el-table__fixed-header-wrapper #setting-modal";
    const el = document.querySelector(selector);

    if (!el) return;

    const absoluteLeft = el.getBoundingClientRect().left;
    const absoluteTop = el.getBoundingClientRect().top;
    const showPosition = document.getElementById("show-setting-modal");

    if (!showPosition) return;

    showPosition.style.left = absoluteLeft + 24 - 240 + "px";
    showPosition.style.top = absoluteTop + 29 + "px";
    showPosition.style.position = "absolute";
  }

  // 保存排序后的更新列表
  refreshTable(headerList: HeaderColumn[]) {
    this.showSortSetting = false;
    this.tableHeaderReady = false;

    localStorage.setItem(this.storageKey, JSON.stringify(headerList));
    this.getShowHeaderList(headerList);

    this.$nextTick(() => {
      this.tableHeaderReady = true;
    });
  }

  checkAll = false;
  checkIdList: number[] = [];

  selectAllList(commandStr: string) {
    if (commandStr === "select-page") {
      this.checkAll = false;
      this.checkIdList = Array.from(
        new Set([
          ...this.checkIdList,
          ...this.data.map(item => item.candidateId)
        ])
      );
      this.data.forEach(item => {
        (this.$refs.multipleTable as any).toggleRowSelection(item, true);
      });
    }

    if (commandStr === "select-all") {
      this.checkAll = true;
      const preLength = (this.searchForm.page + 1) * this.searchForm.pageSize;
      const page = this.searchForm.page;
      this.searchForm.page = 1;

      ExamList.getCandidateListIds(this.searchForm).then(res => {
        this.checkIdList = res.data.candidateIds;

        // 如果当前页数据没在全选行列内，回第一页
        if (preLength > 4000) return this.refresh();

        this.searchForm.page = page;
        this.data.forEach(item => {
          (this.$refs.multipleTable as any).toggleRowSelection(item, true);
        });
      });
    }
  }

  handleCheckRow(selection: CandidateV3Item[], row: CandidateV3Item) {
    const index = this.checkIdList.findIndex(id => id === row.candidateId);

    if (index >= 0) {
      this.checkIdList.splice(index, 1);

      if (this.checkIdList.length === 0) {
        (this.$refs.multipleTable as any).clearSelection();
      }

      return;
    }

    if (this.checkIdList.length >= 4000) {
      this.$message.warning("最多选中4000条");
      return (this.$refs.multipleTable as any).toggleRowSelection(row, false);
    }

    this.checkIdList.push(row.candidateId);

    if (selection.length === 1) {
      this.selectedItem = selection[0];
    }
  }

  @Watch("data", { deep: true })
  handleDataChange() {
    this.data.forEach(item => {
      (this.$refs.multipleTable as any).toggleRowSelection(
        item,
        this.checkIdList.includes(item.candidateId)
      );
    });
  }

  handleClearSelected() {
    this.checkAll = false;
    this.checkIdList = [];
    (this.$refs.multipleTable as any).clearSelection();
  }

  // 列表内容
  formatTimeToday(time: string) {
    if (!time || time === "0001-01-01 00:00:00") return "-";

    return TimeUtil.formatTimeToday(time);
  }

  getStatusLabel(submitStatus: EnumSubmitStatus, target: "class" | "text") {
    const textMap = {
      [EnumSubmitStatus.EnumSubmitStatusNotSignIn]: "未登记",
      [EnumSubmitStatus.EnumSubmitStatusSignIn]: "已登记",
      [EnumSubmitStatus.EnumSubmitStatusAnswering]: "面试中"
    };

    const classMap = {
      [EnumSubmitStatus.EnumSubmitStatusNotSignIn]: "info",
      [EnumSubmitStatus.EnumSubmitStatusSignIn]: "info",
      [EnumSubmitStatus.EnumSubmitStatusAnswering]: "primary"
    };

    return target === "class"
      ? classMap[submitStatus] || "success"
      : textMap[submitStatus] || "面试完成";
  }

  scoreAiConvert(
    submitStatus: EnumSubmitStatus,
    scoreAi: number,
    aiProcessStatus: EnumProcessStatus
  ) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(submitStatus)
    ) {
      return "-";
    }

    if (
      [
        EnumSubmitStatus.EnumSubmitStatusFinish,
        EnumSubmitStatus.EnumSubmitStatusNoScore
      ].includes(submitStatus)
    ) {
      return aiProcessStatus === EnumProcessStatus.EnumProcessStatusFinish
        ? scoreAi
        : "正在打分";
    }
  }

  aiRecommendStatusConvert(
    aiRecommendStatus: EnumAiRecommendStatus,
    target: "class" | "text"
  ) {
    const textMap = {
      [EnumAiRecommendStatus.EnumAiRecommendStatusDefault]: "-",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNotRecommend]: "不推荐",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNormal]: "一般",
      [EnumAiRecommendStatus.EnumAiRecommendStatusRecommend]: "推荐",
      [EnumAiRecommendStatus.EnumAiRecommendStatusVeryRecommend]: "非常推荐"
    };

    const classMap = {
      [EnumAiRecommendStatus.EnumAiRecommendStatusDefault]: "",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNotRecommend]: "warning",
      [EnumAiRecommendStatus.EnumAiRecommendStatusNormal]: "info",
      [EnumAiRecommendStatus.EnumAiRecommendStatusRecommend]: "primary",
      [EnumAiRecommendStatus.EnumAiRecommendStatusVeryRecommend]: "success"
    };

    return target === "class"
      ? classMap[aiRecommendStatus]
      : textMap[aiRecommendStatus];
  }

  auditStatusConvert(auditStatus: EnumAuditStatus, target: "class" | "text") {
    const textMap = {
      [EnumAuditStatus.EnumAuditStatusNoAudit]: "-",
      [EnumAuditStatus.EnumAuditStatusPass]: "通过",
      [EnumAuditStatus.EnumAuditStatusWait]: "待定",
      [EnumAuditStatus.EnumAuditStatusRefuse]: "拒绝"
    };

    const classMap = {
      [EnumAuditStatus.EnumAuditStatusNoAudit]: "",
      [EnumAuditStatus.EnumAuditStatusPass]: "success",
      [EnumAuditStatus.EnumAuditStatusWait]: "info",
      [EnumAuditStatus.EnumAuditStatusRefuse]: "danger"
    };

    return target === "class" ? classMap[auditStatus] : textMap[auditStatus];
  }

  messageStatusConvert(messageStatus: EnumMessageStatus) {
    switch (messageStatus) {
      case EnumMessageStatus.EnumMessageStatusOpenLink:
        return "公开邀请";
      case EnumMessageStatus.EnumMessageStatusNoSend:
        return "未通知";
      case EnumMessageStatus.EnumMessageStatusNoReply:
        return "已通知未打开";
      case EnumMessageStatus.EnumMessageStatusApply:
        return "已通知已打开";
    }
  }

  submitTypeConvert(submitStatus: EnumSubmitStatus, submitType: string) {
    if (
      [
        EnumSubmitStatus.EnumSubmitStatusNotSignIn,
        EnumSubmitStatus.EnumSubmitStatusSignIn,
        EnumSubmitStatus.EnumSubmitStatusAnswering
      ].includes(submitStatus)
    ) {
      return "-";
    }

    return submitType;
  }

  getParamValue(row: CandidateV3Item, columnName?: string) {
    return (
      row.paramList.find(item => item.name === columnName)?.cascadeValue || "-"
    );
  }

  getVersion(row: CandidateV3Item) {
    const el = this.versionList.find(
      version => version.value === row.examVersionId
    );
    console.log(el);
    return el ? el.label : "-";
  }

  // 异常提示弹窗
  errorText = "";
  showErrorInfo = false;

  showError(row: CandidateV3Item) {
    let t = ``;

    const bgCheckIdentityRes = row.errorInfoList.find(
      item => item.task == "bgCheckIdentity"
    );

    row.errorInfoList.forEach(item => {
      if (!errorEnum[item.task]) return;

      if (item.result !== 1) return;

      // 风险等级
      if (
        item.task === "bgCheckSocial" &&
        row.bgCheckResult.socialInfoStatus === 3 &&
        row.bgCheckResult.socialInfoErrorLevel &&
        row.bgCheckResult.socialInfoErrorLevel > 0
      ) {
        // 如果没有背调-手机号实名认证没通过，查不到金融风险和社会安全风险
        if (bgCheckIdentityRes?.result === 1) return;

        const msgMap = [
          "",
          "候选人存在低社会安全风险",
          "候选人存在中社会安全风险",
          "候选人存在高社会安全风险",
          "候选人社会安全风险存在异常"
        ];

        t += `${msgMap[row.bgCheckResult.socialInfoErrorLevel]}<br/>`;
        return;
      }

      if (
        item.task === "bgCheckFinancial" &&
        row.bgCheckResult.financialRiskStatus === 3 &&
        row.bgCheckResult.financialRiskErrorLevel &&
        row.bgCheckResult.financialRiskErrorLevel > 0
      ) {
        // 如果没有背调-手机号实名认证没通过，查不到金融风险和社会安全风险
        if (bgCheckIdentityRes?.result === 1) return;

        const msgMap = [
          "",
          "候选人存在低金融风险",
          "候选人存在中金融风险",
          "候选人存在高金融风险",
          "候选人金融风险存在异常"
        ];

        t += `${msgMap[row.bgCheckResult.financialRiskErrorLevel]}<br/>`;
        return;
      }

      let errorMessage = errorEnum[item.task];
      if (item.task === "faceCheck") {
        errorMessage = item?.resMessage ? item.resMessage : errorMessage;
      }

      t += `${errorMessage || ""}<br/>`;
    });

    this.errorText = t;
    this.showErrorInfo = true;
  }

  // 报告页
  async candidateReport(row: CandidateV3Item) {
    let previewUrl = `/candidate-info?connectCode=${
      row.connectCode
    }&companyId=${Auth.companyId}${
      row.subExamId ? "&subExamId=" + row.subExamId : ""
    }`;

    //加密报告秘钥
    await NR.getSid({
      companyId: Auth.companyId,
      candidateId: row.candidateId
    }).then(res => {
      previewUrl += "&sid=" + res.sid;
    });
    //获取报告鉴权tid
    await Decrypt.get({
      candidateId: String(row.candidateId)
    }).then(res => {
      previewUrl += "&tid=" + res.tid;
    });

    window.open(previewUrl);
  }

  // 评估页
  async candidateEvaluate(row: CandidateV3Item) {
    ExamList.getCandidateListIds(this.searchForm).then(async res => {
      const searchForm: CandidateListForm = JSON.parse(
        JSON.stringify(this.searchForm)
      );
      searchForm.candidateIdList = res.data.candidateIds;

      if (searchForm.createdTime.length === 0) {
        searchForm.createdTime = ["1970-01-01 00:00:00", "2999-01-01 00:00:00"];
      }

      sessionStorage.setItem("candidateParams", JSON.stringify(searchForm));
      const cid = Auth.companyId;

      let previewUrl = `/exam/mark?examId=${this.examId}&companyId=${cid}&auditStatus=${row.auditStatus}&connectCode=${row.connectCode}`;
      //获取报告鉴权tid
      await Decrypt.get({
        candidateId: String(row.candidateId)
      }).then(res => {
        previewUrl += "&tid=" + res.tid;
      });
      window.open(previewUrl);
    });
  }

  // 操作弹窗
  selectedIdList: number[] = [];
  selectedItem = new CandidateV3Item();
  editTagFlag = false;
  editRemarkFlag = false;
  sendInterviewFlag = false;
  sendResultFlag = false;
  reInterviewFlag = false;
  deleteFlag = false;
  mDeleteFlag = false;
  downloadFlag = false;
  tagType = EnumTagType.EnumTagTypeDefault;

  addTagCallback() {
    this.refresh();
    this.editTagFlag = false;
    this.clear();
  }

  clear() {
    this.selectedIdList = [];
    this.selectedItem = new CandidateV3Item();
    this.handleClearSelected();
  }

  getTagColor(prop: EnumTagColor) {
    return EnumTagColor[prop ?? "tags"];
  }

  // 操作
  async operate(
    { flag, row, prop }: { flag: string; row?: CandidateV3Item; prop?: string },
    e?: any
  ) {
    if (e?.disabled) return;

    if (row) {
      this.selectedIdList = [row.candidateId];
      this.selectedItem = row;
    } else {
      this.selectedIdList = this.checkIdList;
    }

    switch (flag) {
      case "watchReport":
        if (row) {
          this.candidateReport(row);
        }
        break;
      case "markCandidate":
        if (!row) return;
        this.candidateEvaluate(row);
        break;
      case "delete":
        this.deleteFlag = true;
        break;
      case "mDdelete":
        this.mDeleteFlag = true;
        break;
      case "export":
        this.exportCandidate();
        break;
      case "editTag":
        this.tagType = EnumTagMap[prop ?? "tagsInvite"];
        this.editTagFlag = true;
        break;
      default:
        this[flag + "Flag"] = true;
    }
  }

  // 删除
  delSubmit() {
    if (this.selectedItem.candidateId > 0) {
      const params = new CandidateGet();
      params.candidateId = this.selectedItem.candidateId;
      params.companyId = parseInt(Auth.companyId);

      Candidate.delCandidate(params)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("删除成功");
            this.refresh();
            this.del();
          } else {
            this.$message.error(resp.message);
          }
        })
        .then(() => {
          this.deleteFlag = false;
        });
    } else {
      this.$message.error("候选人不存在");
    }
  }

  mDelSubmit() {
    if (this.checkIdList.length > 0) {
      const params = new MDelete();
      params.candidateIdList = this.checkIdList;
      params.companyId = parseInt(Auth.companyId);

      Candidate.mDelete(params)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("删除成功");
            this.refresh();
            this.handleClearSelected();
            this.del();
          } else {
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.mDeleteFlag = false;
        });
    } else {
      this.$message.error("请选择需要删除的候选人");
    }
  }

  // 导出
  exportCandidate() {
    if (this.checkIdList.length <= 0) {
      this.$message.error("请选择要导出的候选人");
      return;
    }

    const searchForm: CandidateListForm = JSON.parse(
      JSON.stringify(this.searchForm)
    );

    searchForm.candidateIdList = this.checkIdList;

    ExamList.candidateListExport(searchForm).then(res => {
      if (res.code !== 0) return;

      if (res.data.isAsync === 1) {
        this.downloadFlag = true;
      } else {
        const dataUrl = res.data.ossUrl;
        const a = document.createElement("a");
        a.href = dataUrl;
        a.setAttribute("download", "候选人列表");
        a.click();
      }
    });
  }

  created() {
    this.getListFeaturesList();

    if (this.scene === "exam") {
      this.paramList = this.headerParams;
      this.getVersionList();
    }

    const listStyle = localStorage.getItem(`style_${this.storageKey}`);
    this.isWideList = listStyle ? listStyle === "wide" : true;
  }

  @Emit()
  quickSearch(type: string, row: CandidateV3Item) {
    return { type, row };
  }

  @Emit()
  refresh() {
    return this.examId;
  }

  @Emit()
  del() {
    return this.examId;
  }

  // select 样式
  initSelectInputStyle() {
    const selectElList = document.querySelectorAll(".list-filter-item.select");
    selectElList.forEach(item => {
      const inner: any = item.querySelector(".el-input__inner");
      const prefix: any = item.querySelector(".el-input__prefix");
      const placeholder: any = item.querySelector(".placeholder");

      if (!inner || !prefix) return;

      inner.style.paddingLeft = `${prefix.offsetWidth + 18}px`;

      if (!placeholder) return;

      placeholder.style.paddingLeft = `${prefix.offsetWidth + 18}px`;
      placeholder.style.paddingRight = `62px`;
    });

    const timeElList = document.querySelectorAll(".list-filter-item.time");
    timeElList.forEach(item => {
      const date: any = item.querySelector(".el-date-editor");
      const placeholder: any = item.querySelector(".placeholder");

      if (!date || !placeholder) return;

      const pl = window.getComputedStyle(date, "before").width.slice(0, -2);

      placeholder.style.paddingLeft = `${Number(pl) + 18}px`;
      placeholder.style.paddingRight = `62px`;
    });
  }

  mounted() {
    this.initSelectInputStyle();
  }
}
